import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Field, FieldArray, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {Badge, Button, ButtonToolbar, Card, Col, Form, Row} from "react-bootstrap";

import {Link} from 'react-router-dom';
import {DateField, FileField, formatDate, scrollToErrors, SelectField, TextField} from '../form/form';
import {Acl, Date, decimalEqual, Enums, Files, formatMoney, Party} from "../../utils";
import MoneyField from "../form/MoneyField";

const validate = (values, b, c) => {
	const errors = {};
	if (!values.title) {
		errors.title = 'Zadejte prosím popis'
	}
	if (!values.abbr) {
		errors.abbr = 'Zadejte prosím zkratku'
	}
	if (!values.partyFromId) {
		errors.partyFromId = 'Vyberte prosím dodavatele'
	}
	if (!values.partyToId) {
		errors.partyToId = 'Vyberte prosím odběratele'
	} else if (values.partyToId === values.partyFromId) {
		errors.partyToId = 'Odběratel a dodavatel jsou stejní'
	}

	if (!values.issuedDate) {
		errors.issuedDate = 'Zadejte prosím vystavení'
	}
	if (!values.taxDate) {
		errors.taxDate = 'Zadejte prosím DUZP'
	}
	if (!values.dueDate) {
		errors.dueDate = 'Zadejte prosím splatnost'
	}

	const amounts = validateAmounts(values, errors);

	if (amounts['sum'] && values.parts) {
		let sumSum = 0;
		let lastPartyId = null;
		for (let partyId in values.parts) {
			if (!values.parts.hasOwnProperty(partyId)) {
				continue;
			}
			if (values.parts[partyId].sumAmount) {
				sumSum += 1 * values.parts[partyId].sumAmount;
				lastPartyId = partyId;
			}
		}
		if (lastPartyId && sumSum && sumSum !== amounts['sum']) {
			errors.parts = {};
			errors.parts[lastPartyId] = {'sumAmount': 'Zbývá ' + formatMoney(amounts['sum'] - sumSum)};
		}
	}

	const itemsErrors = {};
	if (!values.items || !values.items.length) {
		itemsErrors['_error'] = 'Zadejte prosím položky faktury';
	} else {
		let sumSum = 0, taxSum = 0, totalSum = 0;
		for (let i = 0; i < values.items.length; i++) {
			const item = values.items[i];
			const itemErrors = {};
			if (!item.title) {
				itemErrors.title = 'Zadejte prosím popis';
			}

			const itemAmounts = validateAmounts(item, itemErrors);
			sumSum += itemAmounts['sum'];
			taxSum += itemAmounts['tax'];
			totalSum += itemAmounts['total'];

			if (Object.keys(itemErrors).length) {
				itemsErrors[i] = itemErrors;
			}
		}

		if (sumSum !== amounts['sum']) {
			itemsErrors['_error'] = 'Zbývá základ ' + formatMoney(amounts['sum'] - sumSum);
		} else if (taxSum !== amounts['tax']) {
			itemsErrors['_error'] = 'Zbývá DPH ' + formatMoney(amounts['tax'] - taxSum);
		} else if (totalSum !== amounts['total']) {
			itemsErrors['_error'] = 'Zbývá celkem ' + formatMoney(amounts['total'] - totalSum);
		}
	}

	if (Object.keys(itemsErrors).length) {
		errors.items = itemsErrors;
	}

	return errors
};

const validateAmounts = (values, errors) => {
	const amounts = {'sum': 0, 'tax': 0, 'total': 0};
	if (!values.sumAmount) {
		errors.sumAmount = 'Zadejte prosím základ'
	} else {
		amounts['sum'] = 1 * values.sumAmount;
	}

	if (!values.taxAmount) {
		// ok
	} else {
		amounts['tax'] = 1 * values.taxAmount;
	}

	if (!values.totalAmount) {
		if (amounts['sum']) {
			errors.totalAmount = 'Součet je ' + formatMoney(amounts['sum'] + amounts['tax']);
		} else {
			errors.totalAmount = 'Zadejte prosím celkem';
		}
	} else {
		amounts['total'] = 1 * values.totalAmount;
	}

	if (amounts['sum'] && amounts['total']) {
		if (!decimalEqual(amounts['sum'] + amounts['tax'], amounts['total'])) {
			errors.totalAmount = formatMoney(amounts['sum']) + ' + ' + formatMoney(amounts['tax']) + ' = ' + formatMoney(amounts['sum'] + amounts['tax']);
		}
	}
	console.log(amounts)

	return amounts;
};

const statusOptions = [
	{label: 'Výhled', value: 'OUTLOOK'},
	{label: 'Neuhrazená', value: 'PENDING'},
	{label: 'Odeslaná', value: 'SENT'},
	{label: 'Častečně', value: 'PARTIAL'},
	{label: 'Uhrazená', value: 'PAID'}
];

class InvoiceForm extends Component {

	constructor(props) {
		super(props);

		this.renderInvoiceItems = this.renderInvoiceItems.bind(this);
		this.handleIssuedDateChange = this.handleIssuedDateChange.bind(this);
	}

	handleIssuedDateChange(value) {
		if (value) {
			this.props.change('dueDate', Date.addDays(value, 19)); // XXX
		}
	}

	renderInvoiceItems({fields, meta: {error, submitFailed}}) {
		const {change} = this.props;
		return <div>
			{fields.map((member, index) => (
				<Row key={index}>
					<Col md={1}>
						<Row>
							<Col md={6}>
								<Button size={"sm"} variant={"warning"} onClick={() => {
									const newItems = [];
									for (let i = 0; i < fields.length; i++) {
										if (i === index) {
											continue;
										}
										const newItem = fields.get(i);
										newItem.orderNo = newItems.length + 1;
										newItems.push(newItem)
									}
									change('items', newItems);
								}}><i className={"fa fa-times"}/> </Button>
							</Col>
							<Col md={6}>
								<Field label='#' name={`${member}.orderNo`} type='text' component={TextField} maxLength="3" sizes={[0, 12]}
									plaintext={true} readOnly={true} className={"text-right"}/>
							</Col>
						</Row>
					</Col>
					<Col md={6}>
						<Field label='Popis' name={`${member}.title`} type='text' component={TextField} maxLength="200" sizes={[0, 12]}/>
					</Col>
					<Col md={5}>
						<Row>
							<Col md={4}>
								<Field label='Základ' name={`${member}.sumAmount`} type='text' component={MoneyField} maxLength="12" sizes={[0, 12]}/>
							</Col>
							<Col md={4}>
								<Field label='DPH' name={`${member}.taxAmount`} type='text' component={MoneyField} maxLength="12" sizes={[0, 12]}/>
							</Col>
							<Col md={4}>
								<Field label='Celkem' name={`${member}.totalAmount`} type='text' component={MoneyField} maxLength="12" sizes={[0, 12]}/>
							</Col>
						</Row>
					</Col>
				</Row>
			))}
			<Row key={'new'}>
				<Col md={1}>
					<Row>
						<Col md={6}>
							<Button size={"sm"} variant={"info"} title="Přidat položku" onClick={() => {
								fields.push({
									orderNo: fields.length + 1
								});
							}}><i className={"fa fa-plus"}/> </Button>
						</Col>
					</Row>
				</Col>
				{error ? <Col md={11}>
					<div className={"text-danger"}>{error}</div>
				</Col> : null}
			</Row>
		</div>
	}

	render() {
		const {
			handleSubmit, initialValues, submitting,
			enums, session,
			onSaveInvoice, onDeleteInvoice,
			formState, change
		} = this.props;

		const partyOptions = Enums.createEnumItems(enums, "parties", true, true);

		const partyFromId = formState && formState.values ? formState.values.partyFromId : null;
		const accountFromOptions = Party.getPartyAccountOptions(partyFromId, enums);

		const partyToId = formState && formState.values ? formState.values.partyToId : null;
		const accountToOptions = Party.getPartyAccountOptions(partyToId, enums);

		const userParty = Party.getUserParty(partyFromId, session) || Party.getUserParty(partyToId, session);

		const parts = [];
		if (userParty && userParty.extra && userParty.extra.partners) {
			for (let i = 0; i < userParty.extra.partners.length; i++) {
				const p = Enums.getEnumByAbbr(enums, 'parties', userParty.extra.partners[i].partyAbbr);
				parts.push(<Row key={i}>
					<Col lg={12}>
						<Field label={p.abbr} name={`parts[${p.id}].sumAmount`} type='text' component={MoneyField} maxLength="12" sizes={[4, 8]}/>
					</Col>
				</Row>)
			}
		}

		const effStatusOptions = Object.assign([], statusOptions);
		if (initialValues.status && initialValues.status === 'DELETED') {
			effStatusOptions.push({label: '(smazaná)', value: 'DELETED'});
		} else if (initialValues.status && initialValues.status === 'FAILED') {
			effStatusOptions.push({label: '(chyba)', value: 'FAILED'});
		}

		return (
			<Form noValidate onSubmit={handleSubmit((values) => {
				return onSaveInvoice(values)
			})} className={"detail"}>
				<Row>
					<Col lg={6}>
						<Card>
							<Card.Header>Faktura {initialValues.invoiceNo}
								{initialValues.invoiceId ? <Badge variant={"dark"} className="pull-right">ID {initialValues.invoiceId}</Badge> : null}</Card.Header>
							<Card.Body>
								<Row>
									<Col xs={12}>
										<Field label='Popis' required name="title" type='text' component={TextField} maxLength="200" sizes={[2, 10]}/>
									</Col>
								</Row>
								<Row>
									<Col xs={6}>
										<Field label="Číslo" name="invoiceNo" type='text' component={TextField} maxLength="100"/>
									</Col>
									<Col xs={6}>
										<Field label="Zkratka" name="abbr" type='text' component={TextField} maxLength="50"/>
									</Col>
								</Row>
								<Row className={"divider"}>
									<Col xs={12}>
										<Field label="Dodavatel" name="partyFromId" type="select" component={SelectField} sizes={[2, 10]} options={partyOptions}
											onChangeHook={(id) => Party.handlePartyChange('accountFromId', id, enums, change)}/>
									</Col>
								</Row>
								<Row>
									<Col xs={12}>
										<Field label={false} name="accountFromId" type="select" component={SelectField} sizes={[2, 10]} options={accountFromOptions}/>
									</Col>
								</Row>
								<Row>
									<Col xs={2}/>
									<Col xs={4}>
										<Field label={"VS"} name="varSym" type='text' component={TextField} maxLength="10" sizes={[0, 12]}/>
									</Col>
									<Col xs={2}>
										<Field label={"KS"} name="constSym" type='text' component={TextField} maxLength="4" sizes={[0, 12]}/>
									</Col>
									<Col xs={4}>
										<Field label={"SS"} name="specSym" type='text' component={TextField} maxLength="10" sizes={[0, 12]}/>
									</Col>
								</Row>
								<Row className={"divider"}>
									<Col xs={12}>
										<Field label="Odběratel" name="partyToId" type="select" component={SelectField} sizes={[2, 10]} options={partyOptions}
											onChangeHook={(id) => Party.handlePartyChange('accountToId', id, enums, change)}/>
									</Col>
								</Row>
								<Row>
									<Col xs={12}>
										<Field label={false} name="accountToId" type="select" component={SelectField} sizes={[2, 10]} options={accountToOptions}/>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
					<Col lg={6}>
						<Row>
							<Col lg={12}>
								<Card>
									<Card.Header>&nbsp;</Card.Header>
									<Card.Body>
										<Row>
											<Col xs={6}>
												<Field label="Vystavení" name={"issuedDate"} type='date' component={DateField} maxLength="12" format={formatDate}
													onChangeHook={this.handleIssuedDateChange}/>
											</Col>
											<Col md={6}>
												<Field label='Základ' name="sumAmount" type='text' component={MoneyField} maxLength="12" sizes={[4, 8]}/>
											</Col>
										</Row>
										<Row>
											<Col xs={6}>
												<Field label="DUZP" name={"taxDate"} type='date' component={DateField} maxLength="12" format={formatDate}/>
											</Col>
											<Col md={6}>
												<Field label='DPH' name="taxAmount" type='text' component={MoneyField} maxLength="12" sizes={[4, 8]}/>
											</Col>
										</Row>
										<Row>
											<Col xs={6}>
												<Field label="Splatnost" name={"dueDate"} type='date' component={DateField} maxLength="12" format={formatDate}/>
											</Col>
											<Col md={6}>
												<Field label='Celkem' name="totalAmount" type='text' component={MoneyField} maxLength="12" sizes={[4, 8]}/>
											</Col>
										</Row>
										<Row className="divider">
											<Col xs={6}>
												<Row>
													<Col xs={12}>
														<Field label="Stav" name="status" type="select" component={SelectField} options={effStatusOptions}/>
													</Col>
												</Row>
												<Row>
													<Col xs={12}>
														<Field label="Uhrazeno" name={"paidDate"} type='date' component={DateField} maxLength="12" format={formatDate} clearable/>
													</Col>
												</Row>
											</Col>
											<Col xs={6}>
												{parts}
											</Col>
										</Row>
										<Row className="divider">
											<Col xs={12}>
												<FileField label="Doklad" name="fileId" fileContainer="file" sizes={[2, 10]}
													fileTitle={initialValues.fileName}
													fileSrc={initialValues.fileId ? Files.getLink(initialValues.fileId) : false}
													formState={formState}
													change={this.props.change}/>
											</Col>
										</Row>
									</Card.Body>
								</Card>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<Card>
							<Card.Header>Položky</Card.Header>
							<Card.Body className={"form-items"}>
								<FieldArray name={"items"} component={this.renderInvoiceItems}/>
							</Card.Body>
						</Card>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<ButtonToolbar className="text-center">
							<Link to={{pathname: "/invoices" + (initialValues.invoiceId ? "/" + initialValues.invoiceId : "")}} className="btn btn-link"> Storno</Link>
							{Acl.hasAction(initialValues, Acl.invoice.DELETE) &&
							<Button variant="danger" type="button" disabled={submitting} onClick={() => onDeleteInvoice(initialValues)}><span className="fa fa-trash"/> Smazat</Button>}
							<Button variant="success" type="submit" disabled={submitting}><span className="fa fa-ok"/> {initialValues.invoiceId ? "Uložit změny" : "Založit fakturu"}</Button>
						</ButtonToolbar>
					</Col>
				</Row>
			</Form>
		)
	}
}

// const selector = formValueSelector('invoice');

InvoiceForm.propTypes = {
	id: PropTypes.number,
	item: PropTypes.object.isRequired,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onSaveInvoice: PropTypes.func.isRequired,
	onDeleteInvoice: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

// export default compose(
// 	connect(state => {
// 		const {partyFromId, partyToId, items} = selector(state, 'partyFromId', 'partyToId', 'items');
// 		return {
// 			partyFromId,
// 			partyToId,
// 			items
// 		}
// 	}),
// 	reduxForm({
// 		form: 'invoice',
// 		validate,
// 		onSubmitFail: scrollToErrors,
// 		// asyncBlurFields: ['invoiceNo']
// 	})
// )(InvoiceForm)

InvoiceForm = reduxForm({
	form: 'invoice',
	validate,
	onSubmitFail: scrollToErrors
})(InvoiceForm);

const mapStateToProps = (state, ownProps) => ({
	formState: state.form.invoice,
});

export default connect(mapStateToProps)(InvoiceForm)
